import { skillGroups } from "../data/portfolioData";

function ChapterArmory() {
  return (
    <section id="armory" className="chapter armory-section" data-section="armory" data-testid="chapter-04-armory">
      <div className="chapter-intro">
        <div className="section-kicker"><span>04</span><span>THE TECHNICAL ARMORY</span></div>
        <div><h2 data-testid="chapter-04-heading">A practical range, not a list.</h2><p className="chapter-lead">Tools matter. The real advantage is knowing which combination makes a customer, a team, or a product stronger.</p></div>
      </div>
      <div className="armory-grid">
        {skillGroups.map((group, index) => (
          <article className="armory-card reveal-item" key={group.code}>
            <div className="armory-code">{group.code}</div><h3>{group.title}</h3>
            <div className="skill-list">{group.skills.map((skill, skillIndex) => <span key={skill} data-testid={`armory-skill-badge-${index}-${skillIndex}`}>{skill}</span>)}</div>
          </article>
        ))}
      </div>
      <div className="learning-strip"><span>EDUCATION /</span><strong>B.IT (HONS) INTERNET TECHNOLOGIES</strong><span>—</span><strong>DIPLOMA OF BUSINESS</strong><span>—</span><strong>ALWAYS LEARNING</strong></div>
    </section>
  );
}

export default ChapterArmory;
